
import React, { useEffect,useState,useRef } from 'react';
import {Modal,Button } from 'antd'
// import {api_candidates_list} from '../../../api';
// import { ProTable } from '@ant-design/pro-components';
// import { UnorderedListOutlined } from '@ant-design/icons';
import Candtrace from './candtrace';

const screenHeight = document.body.clientHeight;
// const screenWidth = document.body.clientWidth;

const App = (props) => {
    const {showModal, closeModal, tenant_id, candidate_id} = props;

    useEffect(() => {
        // if(showModal && rowInfo.work_order_id)
        //   actionRef.current?.reload();
            // setTableData(JSON.parse(rowInfo.client_list));
        // else
        //     setTableData([]);
      }, []);
  
    return (
      <div>
        <Modal 
            key="candtraceModel"
            title={'候选人任务溯源'}
            open={showModal}
            width={"70%"}
            // bodyStyle={{height:screenHeight*0.5,overflowY:"scroll"}}
            centered
            maskClosable={false}
            footer={[<Button  className="m-btn-white" onClick={closeModal}>
            关闭
            </Button>,] }
            onCancel={closeModal}>


          <Candtrace
            tenant_id={tenant_id}
            candidate_id={candidate_id}
          />

        </Modal>

      </div>

    )
}

export default App